/**
 * SF-145 (20/10/2026) · Marca del clic del anuncio.
 *
 * El widget se monta DENTRO de la página que lo carga (no es un iframe), así
 * que ve la URL y las cookies de segurosfly.com. Aquí se lee lo que el píxel
 * de Meta (_fbc, _fbp) y el de Google (_gcl_aw) dejan en el navegador, más
 * fbclid/gclid si vienen en la URL, y se manda con la cotización. Con eso el api
 * puede avisar a Meta de la COMPRA aunque se pague días después, por WhatsApp
 * o desde el CMS.
 *
 * Nunca rompe la cotización: cualquier error devuelve null.
 */

function leerCookie(nombre) {
  try {
    const par = document.cookie.split('; ').find((c) => c.startsWith(`${nombre}=`));
    return par ? decodeURIComponent(par.slice(nombre.length + 1)) : undefined;
  } catch {
    return undefined;
  }
}

/** fbclid/gclid persisten aquí por si el visitante navega antes de cotizar. */
const CLAVE = 'sf_marca_clic';

function recordados() {
  try {
    return JSON.parse(localStorage.getItem(CLAVE) || '{}') || {};
  } catch {
    return {};
  }
}

/** Llamar al montar el widget: guarda fbclid/gclid de la URL de entrada. */
export function recordarMarcaDeUrl() {
  try {
    const p = new URLSearchParams(window.location.search);
    const fbclid = p.get('fbclid');
    const gclid = p.get('gclid');
    if (!fbclid && !gclid) return;
    const prev = recordados();
    const ahora = Date.now();
    localStorage.setItem(
      CLAVE,
      JSON.stringify({
        ...prev,
        ...(fbclid ? { fbclid, fbclidAt: ahora } : {}),
        ...(gclid ? { gclid, gclidAt: ahora } : {}),
      }),
    );
  } catch {
    /* sin almacenamiento: se usa solo la URL actual */
  }
}

/** Lo que va en el body de quoterlanding/create como `marcaClic`. */
export function leerMarcaClic() {
  try {
    const p = new URLSearchParams(window.location.search);
    const r = recordados();
    const NOVENTA_DIAS = 90 * 24 * 60 * 60 * 1000;
    const vigente = (t) => typeof t === 'number' && Date.now() - t < NOVENTA_DIAS;

    const fbclid = p.get('fbclid') || (vigente(r.fbclidAt) ? r.fbclid : undefined);
    let fbc = leerCookie('_fbc');
    // Sin píxel (bloqueador, consentimiento) pero con fbclid: se arma como Meta lo pide.
    if (!fbc && fbclid) fbc = `fb.1.${r.fbclidAt || Date.now()}.${fbclid}`;
    const fbp = leerCookie('_fbp');

    // gclid: de la URL, de lo recordado, o de la cookie de Google (GCL.<ts>.<gclid>).
    let gclid = p.get('gclid') || (vigente(r.gclidAt) ? r.gclid : undefined);
    if (!gclid) {
      const aw = leerCookie('_gcl_aw');
      if (aw) gclid = aw.split('.').slice(2).join('.') || undefined;
    }

    if (!fbc && !fbp && !fbclid && !gclid) return null;
    return {
      ...(fbc ? { fbc } : {}),
      ...(fbp ? { fbp } : {}),
      ...(fbclid ? { fbclid } : {}),
      ...(gclid ? { gclid } : {}),
      url: `${window.location.origin}${window.location.pathname}`,
    };
  } catch {
    return null;
  }
}
